import React from "react";
import { bool, func, string } from "prop-types";
import * as style from "./styles.module.scss";

import { isSmallerThanDesktop } from "../../helpers";
import { useWindowDimensions } from "../../helpers/hooks";

const UploadingSuccess = ({ fileCategory, onClose, isUpdating = false }) => {
  const { width } = useWindowDimensions();
  return (
    <div className={style.fileUploadStatus__background}>
      <div className={style.fileUploadStatus__container}>
        <div className={style.fileUploadStatus__info}>
          <img src="/images/icons/timesheet-approve.svg" />
          <h4 className="mt-2">
            <span style={{ textTransform: "capitalize" }}>{fileCategory}</span>{" "}
            {isUpdating ? "updated" : "uploaded"} successfully
          </h4>
          <p className="mx-2 font-weight-bold">
            Your {fileCategory} has been successfully uploaded.
          </p>
        </div>
        <button
          className={`btn btn-primary ${style.fileUploadStatus__btn}`}
          onClick={onClose}
        >
          {isSmallerThanDesktop(width) ? "Back to your account" : "Close"}
        </button>
      </div>
    </div>
  );
};

UploadingSuccess.propTypes = {
  fileCategory: string.isRequired,
  onClose: func.isRequired,
  isUpdating: bool,
};

export default UploadingSuccess;
